import type { Included, Projection } from '@library/types/projection';
import type { LeagueTeamPlayers } from '@library/types/player';

export const getNormalizedName = ({ name }: { name: string }): string => {
  return name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const getNormalizedPlayers = (players: LeagueTeamPlayers) => {
  if (!players) {
    return players;
  }

  return players.map((player) => ({
    ...player,
    normalizedName: getNormalizedName({ name: player.name })
  }));
};

export const getPlayerValues = ({
  included,
  projection
}: {
  included: Array<Included<string>>;
  projection: Projection<string>;
}): {
  foreignId: string;
  playerLeagueId?: number;
  playerLeagueName?: string;
  market?: string | null;
  oddsJamId: boolean;
  playerId: string;
  playerImage?: string;
  playerName: string;
  position?: string;
  sportRadarId: boolean;
  swishId: boolean;
  team?: string;
  teamName?: string | null;
  updatedAt?: string;
} => {
  const player = included.find(
    (include) =>
      include.type === 'new_player' &&
      projection?.relationships?.new_player?.data?.id === include.id
  );

  const {
    attributes: {
      image_url: playerImage,
      league: playerLeagueName,
      league_id: playerLeagueId,
      name: playerName = '',
      market,
      oddsjam_id: oddsJamId,
      position,
      sportsradar_id: sportRadarId,
      swish_id: swishId,
      team,
      team_name: teamName,
      updated_at: updatedAt
    },
    id: playerId = ''
  } = player ?? { attributes: {} };

  const foreignId = sportRadarId ?? oddsJamId ?? swishId ?? '';

  return {
    foreignId,
    market,
    oddsJamId: !sportRadarId && !!oddsJamId,
    playerId,
    playerImage,
    playerLeagueId,
    playerLeagueName,
    playerName,
    position,
    sportRadarId: !!sportRadarId,
    swishId: !sportRadarId && !oddsJamId && !!swishId,
    team,
    teamName,
    updatedAt
  };
};
